import { useTranslation } from "react-i18next";
import "../i18n";
import {ErrorType, LICENSE_EXPIRED, CUSTOMER_IS_NOT_ENABLED, NO_ACCESS_TOKEN, NO_CUSTOMER, NO_LTI, NO_LEARNER_EMAIL_AVAILABLE, NO_LEARNER_NAME_AVAILABLE, NOT_FOUND, USER_HASNT_FINISHED_WATCHING_THE_COURSE, GENERIC_ERROR_MESSAGE,
  DYNAMIC_REGISTRATION_NOT_ENABLED, DEEP_LINKING_NOT_ENABLED, ERROR_IN_LTI_AUTH,COURSE_STATUS_ARCHIVED,COURSE_STATUS_EXPIRED,COURSE_NOT_FOUND
  
 } from "../@types/errors.types";


const useErrors = (error:ErrorType) => {
  const {t} = useTranslation();
  const errorTranslationKeys: Record<ErrorType, {title: string, description: string}> = {
    [NO_ACCESS_TOKEN]: {
      title: t("errors.NO_ACCESS_TOKEN.title"),
      description: t("errors.NO_ACCESS_TOKEN.description")
    },
    [CUSTOMER_IS_NOT_ENABLED]: {
      title: t("errors.CUSTOMER_IS_NOT_ENABLED.title"),
      description: t("errors.CUSTOMER_IS_NOT_ENABLED.description")
    },
    [NO_CUSTOMER]: {
      title: t("errors.NO_CUSTOMER.title"),
      description: t("errors.NO_CUSTOMER.description")
    },
    [NO_LTI]: {
      title: t("errors.NO_LTI.title"),
      description: t("errors.NO_LTI.description")
    },
    [LICENSE_EXPIRED]: {
      title: t("errors.LICENSE_EXPIRED.title"),
      description: t("errors.LICENSE_EXPIRED.description")
    },
    [NO_LEARNER_EMAIL_AVAILABLE]: {
      title: t("errors.NO_LEARNER_EMAIL_AVAILABLE.title"),
      description: t("errors.NO_LEARNER_EMAIL_AVAILABLE.description")
    },
    [NO_LEARNER_NAME_AVAILABLE]: {
      title: t("errors.NO_LEARNER_NAME_AVAILABLE.title"),
      description: t("errors.NO_LEARNER_NAME_AVAILABLE.description")
    },
    [NOT_FOUND]: {
      title: t("errors.NOT_FOUND.title"),
      description: t("errors.NOT_FOUND.description")
    },
    [USER_HASNT_FINISHED_WATCHING_THE_COURSE]: {
      title: t("errors.USER_HASNT_FINISHED_WATCHING_THE_COURSE.title"),
      description: t("errors.USER_HASNT_FINISHED_WATCHING_THE_COURSE.description")
    },
    [GENERIC_ERROR_MESSAGE]: {
      title: t("errors.GENERIC_ERROR.title"),
      description: t("errors.GENERIC_ERROR.description")
    },[DEEP_LINKING_NOT_ENABLED]:{
      title: t("errors.DEEP_LINKING_NOT_ENABLED.title"),
      description: t("errors.DEEP_LINKING_NOT_ENABLED.description")
    },[DYNAMIC_REGISTRATION_NOT_ENABLED]:{
      title: t("errors.DYNAMIC_REGISTRATION_NOT_ENABLED.title"),
      description: t("errors.DYNAMIC_REGISTRATION_NOT_ENABLED.description")
    },[ERROR_IN_LTI_AUTH]:{
      title: t("errors.ERROR_IN_LTI_AUTH.title"),
      description: t("errors.ERROR_IN_LTI_AUTH.description")
    },[COURSE_STATUS_ARCHIVED]:{
      title: t("errors.COURSE_STATUS_ARCHIVED.title"),
      description: t("errors.COURSE_STATUS_ARCHIVED.description")
    },[COURSE_STATUS_EXPIRED]:{
      title: t("errors.COURSE_STATUS_EXPIRED.title"),
      description: t("errors.COURSE_STATUS_EXPIRED.description")
    },[COURSE_NOT_FOUND]:{
      title: t("errors.COURSE_NOT_FOUND.title"),
      description: t("errors.COURSE_NOT_FOUND.description")
    }
    
  };

  console.error(`Received error: ${error}`);
  const {title, description} = errorTranslationKeys[error]
      ?? errorTranslationKeys.GENERIC_ERROR_MESSAGE;
  return {
    title,
    description
  };
};
export {useErrors};
